export default __webpack_public_path__ + "static/media/ruler.6de5825d.png";